import { Box, Stack, Typography, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { getOriginatorRatingLabelId } from 'utils/originator-rating';

interface Props {
  rating?: number | null;
  showLabel?: boolean;
}

const SWrapper = styled(Box)(({ theme }) => ({
  minWidth: '40px',
  minHeight: '40px',
  padding: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.grey[200]}`,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.primary.light,
  fontWeight: 700,
}));

export const OriginatorRatingChip = ({ rating, showLabel = false }: Props) => {
  const labelId = showLabel ? getOriginatorRatingLabelId(rating) : undefined;
  return (
    <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
      <SWrapper>
        <Typography variant="subtitle2" fontWeight={700} noWrap>
          {typeof rating === 'number' && Number.isFinite(rating) ? rating : showLabel ? '-' : '~'}
        </Typography>
      </SWrapper>
      {labelId && (
        <SWrapper>
          <Typography variant="subtitle2" fontWeight={700}>
            <FormattedMessage id={labelId} />
          </Typography>
        </SWrapper>
      )}
    </Stack>
  );
};
